import { RRWEB_VIDEO_PLACEHOLDER_NAMES } from '@simplisafe/compass-web'

export const REPLAYER_SPEED_OPTIONS = [0.5, 1, 2]

export const MIN_VOLUME = 0
export const MAX_VOLUME = 100

// Anything displayed on Feed is a full-size view -> Main.
// Feed shows the stacked recorded players and the persistent cross-nav live player;
// the first main-canvas mirror event marks the Feed->Investigate handoff, after which the mirror
// target alone decides Main.
// compass-web exports name builders, not prefixes - derive the prefixes by dropping the trailing slot/camera id.
export const STACKED_PLAYER_PREFIX = RRWEB_VIDEO_PLACEHOLDER_NAMES.STACKED_PLAYER_RECORDED(0).slice(0, -1)
export const CROSS_NAV_PLAYER_PREFIX = RRWEB_VIDEO_PLACEHOLDER_NAMES.CROSS_NAV_PLAYER('')

export const ERROR_TEXT = 'Unable to retrieve data. Please try again later.'
export const EMPTY_TIMELINE_TEXT = 'No events to show'
